import defaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const CRM_CLIENTS_ORDER_FILTER = {
	namespaced: true,
	state: defaultState(),
	getters,
	mutations,
	actions
}

export default CRM_CLIENTS_ORDER_FILTER
